import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { toSignal } from '@angular/core/rxjs-interop';
import { AppRouterService } from '../../../core/app-router.service';
import { Router } from '@angular/router';
import { DeviceService, IconComponent, IconKey } from '@gains-com/ui-angular';
import { ShellService } from '../../shell.service';

@Component({
  selector: 'app-left-sidenav-button',
  imports: [MatButton, IconComponent],
  templateUrl: './left-sidenav-button.component.html',
  styleUrl: './left-sidenav-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LeftSidenavButtonComponent {
  readonly sidenavLink = input.required<LeftSidenavButton>();
  readonly collapsed = input(false);

  private readonly _router = inject(Router);
  private readonly _shellService = inject(ShellService);
  private readonly _appRouterService = inject(AppRouterService);
  readonly device = inject(DeviceService);

  private readonly _route = toSignal(this._appRouterService.route$, { initialValue: '/' });

  readonly linkActive = computed(() => {
    const link = this.sidenavLink().link;
    const route = this._route();

    return (
      link &&
      ((link === '/' && route === '/') ||
        (link !== '/' && route.startsWith(link)))
    );
  });

  async onButtonClick() {
    const sidenavLink = this.sidenavLink();
    if (sidenavLink.onClick) {
      await sidenavLink.onClick();
    } else {
      await this.navigateToLink();
    }
  }

  async navigateToLink() {
    if (this.device.ltMdScreen()) {
      this._shellService.toggleLeftSidenav();
    }

    await this._router.navigateByUrl(this.sidenavLink().link);
  }
}

export type LeftSidenavButton = LeftSidenavButtonIcon & {
  label: string;
  link: string;
  iconSize?: number;
  count?: number;
  onClick?: () => Promise<void> | void;
};

export type LeftSidenavButtonIcon = { iconKey: IconKey; iconUrl?: never } | { iconUrl: string; iconKey?: never };
